// Types and static toggle configuration for the Communication Preferences
// screen (GEIS-358). The screen groups a set of on/off preferences under a
// "master" toggle that turns its children on/off together.

import { LocalesKey } from 'types/types';

export type ContactField = 'mobilePhone' | 'preferredPhone' | 'email';

export type ContactInformation = Record<ContactField, string>;

export type ToggleGroupKey = 'documentDelivery' | 'careWellness' | 'promotions';

export type ToggleGroupState = {
  // The "Go paperless for all" / "Receive updates" master toggle.
  master: boolean;
  // The per-category child toggles, keyed by item id.
  items: Record<string, boolean>;
};

export type ToggleItemConfig = {
  id: string;
  labelId: LocalesKey;
};

// The full set of values the form holds — used to seed initial state from the
// back end and as the payload handed to the save handler (both wired in
// GEIS-359).
export type CommunicationPreferencesValues = {
  contact: ContactInformation;
  groups: Record<ToggleGroupKey, ToggleGroupState>;
};

// "Benefits and plan documents delivery" child toggles.
export const DOCUMENT_DELIVERY_ITEMS: ToggleItemConfig[] = [
  { id: 'eobs', labelId: 'STR_COMM_PREF_EOBS' },
  { id: 'benefitsDocuments', labelId: 'STR_COMM_PREF_BENEFITS_DOCUMENTS' },
  { id: 'premiumStatements', labelId: 'STR_COMM_PREF_PREMIUM_STATEMENTS' },
  { id: 'newsletters', labelId: 'STR_COMM_PREF_NEWSLETTERS' },
  { id: 'letters', labelId: 'STR_COMM_PREF_LETTERS' },
];

// Shared channel toggles used by both "Care, health and wellness" and
// "Promotions and incentives".
export const CHANNEL_ITEMS: ToggleItemConfig[] = [
  { id: 'email', labelId: 'STR_COMM_PREF_CHANNEL_EMAIL' },
  { id: 'sms', labelId: 'STR_COMM_PREF_CHANNEL_SMS' },
  { id: 'phone', labelId: 'STR_COMM_PREF_CHANNEL_PHONE' },
];
